export const requiredFields = [
  'Longitude',
  'Latitude',
  'd18O_lipidextracted',
  'd2H_lipidextracted',
  'd2H_nitrated',
  'd13C_lipidextracted',
  'd15N_lipidextracted',
  'd34S_lipidextracted',
  'Al',
  'Si',
  'P',
  'S',
  'Cl',
  'K',
  'Ca',
  'Fe',
  'Ni',
  'Cu',
  'Zn',
  'Rb',
  'Sr',
  'Pb',
  'd18O_std_lipidextracted',
  'd2H_std_lipidextracted',
  'd2H_std_nitrated',
  'd13C_std_lipidextracted',
  'd15N_std_lipidextracted',
  'd34S_std_lipidextracted',
  'Al_std',
  'Si_std',
  'P_std',
  'S_std',
  'Cl_std',
  'K_std',
  'Ca_std',
  'Fe_std',
  'Ni_std',
  'Cu_std',
  'Zn_std',
  'Rb_std',
  'Sr_std',
  'Pb_std',
];
